import { createActions } from 'reduxsauce';

import API from '../../api';

import OrderActions from './order';

const { Types, Creators } = createActions({
  getConnectingProfilesRequest: null,
  getConnectingProfilesSuccess: ['connectingProfiles'],
  getConnectingProfilesFailure: ['errorMessage'],

  getSideProfilesRequest: null,
  getSideProfilesSuccess: ['sideProfiles'],
  getSideProfilesFailure: ['errorMessage'],

  getConfigSuccess: ['data'],
  getConfigFailure: ['errorMessage'],
  getConfigRequest: (systemType) => async (dispatch, state) => {
    try {
      const currentState = state();
      const currentSystem = systemType || currentState?.systems?.currentSystem;

      const response = await API.config.get(currentSystem);
      const { ok, problem, data } = response || {};
      const error = data?.error || {};

      const config = response?.data?.config || [];
      const errorMessage = !ok
        ? (error?.message || data?.message || problem)
        : '';

      if (errorMessage) {
        dispatch(Creators.getConfigFailure(errorMessage));
        return;
      }

      dispatch(Creators.getConfigSuccess(config));

      // Update total price and specification
      dispatch(OrderActions.calculateOrderRequest());
      dispatch(OrderActions.calculateFrameOrderRequest());
    } catch (error) {
      dispatch(Creators.getConfigFailure(error.message || error.reason));
    }
  },

  getAluminiumColorsSuccess: ['colors'],
  getAluminiumColorsFailure: ['errorMessage'],
  getAluminiumColorsRequest: () => async (dispatch) => {
    try {
      const response = await API.config.getAluminiumColorsList.list();
      const { ok, problem, data } = response || {};
      const error = data?.error || {};

      const aluminiumColors = response?.data?.aluminiumColors || [];
      const errorMessage = !ok
        ? (error?.message || data?.message || problem)
        : '';

      if (errorMessage) {
        dispatch(Creators.getAluminiumColorsFailure(errorMessage));
        return;
      }

      dispatch(Creators.getAluminiumColorsSuccess(aluminiumColors));
    } catch (error) {
      dispatch(Creators.getAluminiumColorsFailure(error.message || error.reason));
    }
  },

  createAluminiumColorSuccess: null,
  createAluminiumColorFailure: ['errorMessage'],
  createAluminiumColorRequest: (color) => async (dispatch) => {
    try {
      const response = await API.config.createAluminiumColor(color);
      const errorMessage = !response.ok
        ? (response.data?.message || response.problem)
        : '';

      if (errorMessage) {
        dispatch(Creators.createAluminiumColorFailure(errorMessage));
        return;
      }

      dispatch(Creators.createAluminiumColorSuccess());
    } catch (error) {
      dispatch(Creators.createAluminiumColorFailure(error.message || error.reason));
    }
  },

  editAluminiumColorSuccess: null,
  editAluminiumColorFailure: ['errorMessage'],
  editAluminiumColorRequest: (articleCode, color) => async (dispatch) => {
    try {
      const response = await API.config.editAluminiumColor(articleCode, color);
      const errorMessage = !response.ok
        ? (response.data?.message || response.problem)
        : '';

      if (errorMessage) {
        dispatch(Creators.editAluminiumColorFailure(errorMessage));
        return;
      }

      dispatch(Creators.editAluminiumColorSuccess());
    } catch (error) {
      dispatch(Creators.editAluminiumColorFailure(error.message || error.reason));
    }
  },

  toggleManageAluminiumColorsModal: ['isOpen'],
});

export const ConfigTypes = Types;
export default Creators;
